import { useTransitionState } from '@pocketlaw/tetris';
import { Container, StyledLoader } from './styled';
export function MessageLoader(props) {
    const { show } = props;
    const state = useTransitionState(show, 175);
    return (<Container $state={state}>
      <StyledLoader size={7}/>
    </Container>);
}
